/**
 * @desc 校验交货单是否可以和箱子绑定
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierBox.checkDeliveryOrderAndBox.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierBox/deliveryOrder/checkOrderAndBox`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
